var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"30px auto","background-color":"rgba(41, 155, 255, .1)","width":"96%","overflow-y":"auto","height":"53vh","padding-top":"20px"}},[_c('ul',{staticClass:"videoUl"},[_c('li',{staticClass:"videoLi one"},[_c('video-component',{attrs:{"channel":1,"device-info":_vm.deviceInfo,"properties":_vm.portProperties}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }